import { Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '@timechef/core/i18n/i18n.service';

@Pipe({
  name: 'timeLeft',
  standalone: false,
})
export class TimeLeftPipe implements PipeTransform {
  constructor(private i18n: I18nService) {}

  transform(seconds: number) {
    // if less than one hour, return minutes, if less than one day, returns hours, else returns days
    if (seconds < SECONDS_IN_HOUR - SECONDS_IN_MINUTE) {
      return `${Math.ceil(seconds / SECONDS_IN_MINUTE)} ${this.i18n.translate('ABBREVIATION.MINUTES')}`;
    } else if (seconds < SECONDS_IN_DAY - SECONDS_IN_HOUR) {
      return `${Math.ceil(seconds / SECONDS_IN_HOUR)} ${this.i18n.translate('ABBREVIATION.HOURS')}`;
    } else {
      return `${Math.ceil(seconds / SECONDS_IN_DAY)} ${this.i18n.translate('ABBREVIATION.DAYS')}`;
    }
  }
}
const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;
const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
